import { render, staticRenderFns } from "./TextPanelPara.vue?vue&type=template&id=31c8bd89&scoped=true&"
import script from "./TextPanelPara.vue?vue&type=script&lang=js&"
export * from "./TextPanelPara.vue?vue&type=script&lang=js&"
import style0 from "./TextPanelPara.vue?vue&type=style&index=0&id=31c8bd89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8bd89",
  null
  
)

export default component.exports